import { IpfsConfig } from "./IPFSConfig";

export const ipfsGateWay =
  process.env.REACT_APP_INFURA_IPFS_GATEWAY || "https://ipfs.infura.io/ipfs";
export const ipfsConfig: IpfsConfig = {
  host: process.env.REACT_APP_INFURA_IPFS_HOST || "ipfs.infura.io",
  port: Number(process.env.REACT_APP_INFURA_IPFS_PORT) || 5001,
  protocol: process.env.REACT_APP_INFURA_IPFS_PROTOCOL || "https"
};
